import { render } from "./admin.vue?vue&type=template&id=61241c74&scoped=true"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"

import "./admin.vue?vue&type=style&index=0&id=61241c74&lang=scss&scoped=true"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61241c74"]])

export default __exports__